/*=========================================================================================
  File Name: moduleUser.js
  Description: User Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Useror: SpeedCodeLabs
  Useror URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from './moduleWaiterState'
import mutations from './moduleWaiterMutations'
import actions from './moduleWaiterActions'
import getters from './moduleWaiterGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 